/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ForgotPasswordDto
 */
export interface ForgotPasswordDto {
    /**
     * 
     * @type {string}
     * @memberof ForgotPasswordDto
     */
    email?: string | null;
}

/**
 * Check if a given object implements the ForgotPasswordDto interface.
 */
export function instanceOfForgotPasswordDto(value: object): value is ForgotPasswordDto {
    return true;
}

export function ForgotPasswordDtoFromJSON(json: any): ForgotPasswordDto {
    return ForgotPasswordDtoFromJSONTyped(json, false);
}

export function ForgotPasswordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ForgotPasswordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function ForgotPasswordDtoToJSON(json: any): ForgotPasswordDto {
    return ForgotPasswordDtoToJSONTyped(json, false);
}

export function ForgotPasswordDtoToJSONTyped(value?: ForgotPasswordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

